import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { OFormComponent } from 'ontimize-web-ngx';


export class ODataTableCellEditorDateDialog {

  protected _date: any;
  protected _label: string;
  
  protected form: OFormComponent;

  constructor(protected dialogRef: MdDialogRef<ODataTableCellEditorDateDialog>) { }

  initialize(parameters: Object): any {
    this.date = parameters['data'];
    this.label = parameters['label'];
  }

  ngAfterViewInit() {
    if (this.form) {
      this.form.setInsertMode();
    }
  }

  getDateValue() {
    if (this.form) {
      return this.form.getDataValue('dateInput').value;
    }
    return undefined;
  }

  get date(): any {
    return this._date;
  }

  set date(val: any) {
    this._date = val instanceof Date ? val : new Date(val);
  }

  get label(): string {
    return this._label;
  }

  set label(val: string) {
    this._label = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-datatable-cell-editor-date-dialog',
  template: `
    <h2 md-dialog-title>{{ 'TABLE.SELECT_DATE' | oTranslate }}</h2>
    <md-dialog-content>
      <o-form #form show-header="no" style="height: 120px;">
        <o-date-input attr="dateInput" [label]="label" layout-padding [data]="date" required="true"></o-date-input>
      </o-form>
    </md-dialog-content>
    <md-dialog-actions>
      <button md-button class="mat-primary" [md-dialog-close]="getDateValue()">
        <span>{{ 'ACCEPT' | oTranslate | uppercase }}</span>
      </button>
      <button md-button class="mat-primary" [md-dialog-close]="undefined">
        <span>{{ 'CANCEL' | oTranslate | uppercase }}</span>
      </button>
    </md-dialog-actions>
  `,
  styles: [`

  `],
  inputs: [
    'data',
    'label'
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'form': [{ type: ViewChild, args: ['form', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
